var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('AxisSwitchStyled', [_c('div', {
    staticClass: "switcher-wrapper"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('viewCountOfInstance')))]), _c('OnOffToggle', {
    staticClass: "on-off-toggle",
    attrs: {
      "value": _vm.selectedValue
    },
    on: {
      "toggle": _vm.setCountFormat
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }